(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exp-breadcrumb"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const previousPageLink = document.getElementById('breadcrumb-dynamic-link');
    
    if (previousPageLink && document.referrer) {
      const currentHost = window.location.hostname;
      const referrerHost = new URL(document.referrer).hostname;

      if (currentHost === referrerHost) {
        try {
          const referrerPath = new URL(document.referrer).pathname;
          const lastSegment = referrerPath.split('/').filter(Boolean).pop() || 'Home';
          const newTitle = lastSegment
            .replace(/-/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());

          previousPageLink.href = document.referrer;
          previousPageLink.textContent = newTitle;
        } catch (e) {
          previousPageLink.href = document.referrer;
          previousPageLink.textContent = 'Kembali';
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
